<template>
  <dialog-modal
    :show="show"
    @close="$emit('close')">
    <template #title>
      <div
        v-if="isBlankForm"
        class="flex justify-center font-bold">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 text-red-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
        <div
          class="ml-2 text-red-500">
          ユーザ情報を入力してください
        </div>
      </div>
    </template>
    <template #content>
      <div class="col-span-9">
        <div
          class="grid grid-cols-4 text-black py-2 items-center rounded border-blue-400">
          名前
          <input
            v-model="userInfoState.name"
            type="text"
            class="ml-2 pl-2 col-span-3 sm:col-span-2 md:col-span-2 rounded border-blue-400">
        </div>

        <div class="grid grid-cols-4 text-black py-2">
          <p>性別</p>
          <label
            class="mx-1 inline-flex items-center">
            男性
            <input
              v-model="userInfoState.sex"
              type="radio"
              value="1"
              class="form-radio mx-1"
              name="sex" />
          </label>
          <label
            class="mx-1 inline-flex items-center">
            女性
            <input
              v-model="userInfoState.sex"
              type="radio"
              value="2"
              class="form-radio mx-1"
              name="sex" />
          </label>
          <label
            class="mx-1 inline-flex items-center">
            無回答
            <input
              v-model="userInfoState.sex"
              type="radio"
              value="3"
              class="form-radio mx-1"
              name="sex" />
          </label>
        </div>
        <div class="grid grid-cols-4 text-black py-2 items-center">
          <p>郵便番号</p>
          <input
            pattern="[0-9]+"
            maxlength="7"
            :value="userInfoState.postalCode"
            type="text"
            class="ml-2 pl-2 col-span-1 sm:col-span-1 md:col-span-1 rounded border-blue-400"
            @input="userInfoState.postalCode=postalValidate($event)" />
          <button
            class="px-8 py-2 ml-2 rounded bg-gray-600 hover:bg-gray-400 text-white max-w-max shadow-sm hover:shadow-lg"
            @click="searchAddress()">
            住所検索
          </button>
        </div>
        <div
          v-if="execSearchFlag && isAddressBlank"
          class="ml-2 text-red-500">
          住所が見つかりません。
        </div>
        <div class="grid grid-cols-4 text-black py-2 items-center">
          <p>住所</p>
          <input
            v-model="userInfoState.address"
            type="text"
            class="ml-2 pl-2 col-span-3 sm:col-span-2 md:col-span-2 rounded border-blue-400" />
        </div>

        <div class="grid grid-cols-4 text-black py-2 items-center">
          職業
          <select
            v-model="userInfoState.job"
            class="ml-2 pl-2 col-span-3 sm:col-span-2 md:col-span-2 rounded border-blue-400">
            <option />
            <option
              v-for="(n, i) in USER_INFO_JOBS"
              :key="i"
              :value="i + 1">
              {{ n }}
            </option>
          </select>
        </div>

        <div
          v-if="isShowJobTextInput"
          class="grid grid-cols-4 text-black py-2 items-center rounded border-blue-400">
          職業<br>(自由記述)
          <input
            v-model="userInfoState.jobText"
            type="text"
            class="ml-2 pl-2 col-span-3 sm:col-span-2 md:col-span-2 rounded border-blue-400">
        </div>

        <div class="grid grid-cols-4 text-black py-2 items-center">
          勤続年数
          <select
            v-model="userInfoState.serviceYears"
            class="ml-2 pl-2 col-span-3 sm:col-span-2 md:col-span-2 rounded border-blue-400">
            <option />
            <option
              v-for="(n, i) in USER_INFO_SERVICE_YEARS"
              :key="i"
              :value="i + 1">
              {{ n }}
            </option>
          </select>
        </div>
        <div
          v-if="isShowServiceYearsTextInput"
          class="grid grid-cols-4 text-black py-2 items-center rounded border-blue-400">
          勤続年数<br>(自由記述)
          <input
            v-model="userInfoState.serviceYearsText"
            type="text"
            class="ml-2 pl-2 col-span-3 sm:col-span-2 md:col-span-2 rounded border-blue-400">
        </div>

        <div
          class="grid grid-cols-4 text-black py-2 items-center rounded border-blue-400">
          所属先(任意)
          <input
            v-model="userInfoState.affiliation"
            type="text"
            class="ml-2 pl-2 col-span-3 sm:col-span-2 md:col-span-2 rounded border-blue-400">
        </div>
      </div>
    </template>
    <template #footer>
      <button
        class="px-8 py-2 rounded bg-blue-600 hover:bg-blue-400 text-blue-50 max-w-max shadow-sm hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
        :disabled="isBlankForm"
        @click="$emit('checkout-click', examination)">
        決済に進む
      </button>
      <button
        class="px-8 py-2 m-5 rounded bg-red-500 hover:bg-red-400 text-blue-50 max-w-max shadow-sm hover:shadow-lg"
        @click="$emit('back-click')">
        戻る
      </button>
    </template>
  </dialog-modal>
</template>

<script setup>
import {
  computed, ref,
} from 'vue'
import { Core as YubinBangoCore } from 'yubinbango-core'
import DialogModal from '../../../Common/DialogModal.vue'
import { USER_INFO_AREAS } from '@/Constants/areas'
import { USER_INFO_JOBS } from '@/Constants/jobs'
import { USER_INFO_SERVICE_YEARS } from '@/Constants/serviceYears'

const props = defineProps({
  userInfoState: {
    type: Object,
    default: () => ({}),
  },
  show: {
    type: Boolean,
    default: () => false,
  },
})

const emit = defineEmits(['checkout-click', 'back-click', 'close'])
const execSearchFlag = ref(false)

const isShowJobTextInput = computed(() => props.userInfoState.job === 13)
const isShowServiceYearsTextInput = computed(() => props.userInfoState.serviceYears === 10)

const postalValidate = (e) => {
  const re = new RegExp(e.target.pattern)
  const result = re.exec(e.target.value)
  return e.target.value = result ? result[0] : result
}

const isBlankForm = computed(() => {
  let isBlank = false
  if (!props.userInfoState.name
      || !props.userInfoState.sex
      || !props.userInfoState.postalCode
      || (String(props.userInfoState.postalCode).length < 7)
      || !props.userInfoState.address
      || !props.userInfoState.job
      || !props.userInfoState.serviceYears) {
    isBlank = true
  } else if (props.userInfoState.job === 13 && !props.userInfoState.jobText) {
    isBlank = true
  } else if (props.userInfoState.serviceYears === 10 && !props.userInfoState.serviceYearsText) {
    isBlank = true
  }
  return isBlank
})

const isAddressBlank = computed(() => (!props.userInfoState.address))

const searchAddress = () => {
  // props.userInfoState.postalCode = postalCode1.value + postalCode2.value;
  new YubinBango.Core(String(props.userInfoState.postalCode), (addr) => {
    execSearchFlag.value = true
    props.userInfoState.address = addr.region // 都道府県
    props.userInfoState.address += addr.locality // 市区町村
    props.userInfoState.address += addr.street // 町域
  })
}

</script>
